export const setFocus = ref => {
  if (ref.current) {
    const inputElement = ref.current.querySelector("input");
    if (inputElement) {
      inputElement.focus();
    }
  }
};
